import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LIFE_HACKS_PATH } from './Header';

const GUIDE_LINKS = [
  { to: '/guides', label: 'All guides' },
  { to: LIFE_HACKS_PATH, label: 'Moving to Korea' },
  { to: '/guides/f4-visa-guide', label: 'F-4 visa' },
  { to: '/guides/sending-money-to-korea', label: 'Sending money to Korea' },
  { to: '/remittance', label: 'Rate comparison' },
];

const COMPANY_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Corrections & contact' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

export default function Footer() {
  const { i18n } = useTranslation();
  const isKorean = i18n.language === 'ko';

  return (
    <footer className="bg-[#1C1C1C] px-4 py-12 text-white sm:px-6">
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-10 md:grid-cols-5">
        <div className="md:col-span-3">
          <Link to="/" className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-jeok-500">
              <span className="text-lg font-bold" aria-hidden="true">K</span>
            </div>
            <span className="text-xl font-bold">KoreanHub<span className="text-ink-500">.net</span></span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-6 text-ink-400">
            {isKorean
              ? '미국과 한국을 오가며 돈, 비자, 정착 문제를 해결하는 사람들을 위한 출처 기반 가이드입니다.'
              : 'Sourced, maintained guides for people navigating money, visas, and relocation between the United States and Korea.'}
          </p>
          <p className="mt-4 text-xs text-ink-500">
            {isKorean
              ? '현재 영어 중심이며, 중요한 한국어 용어와 체크리스트를 함께 제공합니다.'
              : 'Currently English-first, with Korean terminology and checklists where they matter.'}
          </p>
        </div>

        <FooterLinks title={isKorean ? '가이드' : 'Guides'} links={GUIDE_LINKS} />
        <FooterLinks title={isKorean ? '사이트' : 'Site'} links={COMPANY_LINKS} />
      </div>

      <div className="mx-auto mt-10 flex max-w-5xl flex-col gap-2 border-t border-white/10 pt-6 text-xs text-ink-500 sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 KoreanHub.net</p>
        <p>{isKorean ? '영어 중심 · 한국어 용어 병기' : 'English-first · Korean terminology included'}</p>
      </div>
    </footer>
  );
}

function FooterLinks({ title, links }: { title: string; links: { to: string; label: string }[] }) {
  return (
    <div>
      <h2 className="mb-4 text-sm font-semibold text-white">{title}</h2>
      <ul className="space-y-2.5 text-sm text-ink-400">
        {links.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className="transition-colors hover:text-white">{link.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
